import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light');  // Başlangyç reýim (gündizki)

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');  // Öňki tema localStorage-dan al
    if (storedTheme) {
      setTheme(storedTheme);
    }
  }, []);

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');  // Gijeki reýim üçin 'dark' klassyny goş
      localStorage.setItem('theme', 'dark');  // Tema 'dark' bolanda saxlansyn
    } else {
      document.documentElement.classList.remove('dark');  // Gündizki reýimi saýlamak
      localStorage.setItem('theme', 'light');  // Tema 'light' bolanda saxlansyn
    }
  }, [theme]);

  const toggleTheme = () => setTheme(theme === 'light' ? 'dark' : 'light');  // Tema üýtgetmek funksiýasy

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
